import type { FeedbackData } from '../types';

export interface FeedbackService {
    feedback<T>(data: FeedbackData<T>): Promise<boolean>;
}

export const FeedbackService = Symbol('FeedbackService');
